import { revalidateUserData } from '../../common';

export const FATCAAgreementAction = async () => {
  await revalidateUserData();

  await new Promise((resolve) => setTimeout(resolve, 500));

  return true;
};
